import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiTarget, FiSettings, FiDollarSign, FiUsers, FiPhone, FiCheckCircle, FiRocket } = FiIcons;

const ProgramBreakdown = () => {
  const days = [
    {
      day: 1,
      title: "Niche, Offer & Pricing",
      description: "Clarify who you will serve, what problem you solve, and what AI software offer you'll sell (subscription model).",
      icon: FiTarget
    },
    {
      day: 2,
      title: "Software Setup & Branding",
      description: "Setup sub-account, branding, domain/subdomain, basic automations, dashboards.",
      icon: FiSettings
    },
    {
      day: 3,
      title: "Packaging & Recurring Income Plan",
      description: "Structure your pricing (₹5,000–₹25,000/month), plans, and upsells (agency services).",
      icon: FiDollarSign
    },
    {
      day: 4,
      title: "Funnels & Lead Capture",
      description: "Setup landing page, lead form, WhatsApp/email follow-up flows to book calls or demos.",
      icon: FiUsers
    },
    {
      day: 5,
      title: "Sales Script & Closings",
      description: "Get call script, demo flow, objection handling, and follow-up structure.",
      icon: FiPhone
    },
    {
      day: 6,
      title: "Client Onboarding System",
      description: "How to onboard new clients, invoice, collect recurring payments, and deliver value.",
      icon: FiCheckCircle
    },
    {
      day: 7,
      title: "Launch Day & Action Plan",
      description: "Go live, send campaigns, run outreach, and finalize your 90-Day 1 Crore Game Plan.",
      icon: FiRocket
    }
  ];

  return (
    <section className="program-breakdown py-20 px-4 bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            What We'll Do Together in <span className="text-yellow-400">7 Days</span>
          </h2>
          <p className="text-xl text-gray-300">Complete step-by-step implementation with personal guidance</p>
        </motion.div>

        <div className="timeline-container space-y-8">
          {days.map((day, index) => (
            <motion.div
              key={day.day}
              className="timeline-item flex items-start space-x-6"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="day-number bg-gradient-to-r from-blue-500 to-blue-700 text-white font-bold text-xl w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                {day.day}
              </div>
              
              <div className="day-content bg-white/10 backdrop-blur-lg p-6 rounded-xl flex-1 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <SafeIcon icon={day.icon} className="text-2xl text-yellow-400" />
                  <h3 className="text-xl font-bold">{day.title}</h3>
                </div>
                <p className="text-gray-300 leading-relaxed">{day.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="support-highlight bg-gradient-to-r from-yellow-500/20 to-yellow-600/20 p-8 rounded-2xl mt-12 border border-yellow-500/30"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="text-center">
            <SafeIcon icon={FiCalendar} className="text-4xl text-yellow-400 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-4">Plus: 1 Month Support</h3>
            <p className="text-xl text-yellow-200">Unlimited 1-to-1 Calls for Implementation & Troubleshooting</p>
          </div>
        </motion.div>

        <motion.div 
          className="text-center mt-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          viewport={{ once: true }}
        >
          <motion.a
            href="https://abdul.cc/earnwithabdul"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-bold text-xl px-12 py-6 rounded-full hover:from-yellow-500 hover:to-yellow-700 transition-all duration-300 transform hover:scale-105 shadow-2xl"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Apply Now for the 7-Day Intensive
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ProgramBreakdown;